import { useEffect, useState } from 'react';
import { useMoralis } from 'react-moralis';
import { Link, Navigate } from 'react-router-dom';
import { SecondaryNavigation } from '../../components/SecondaryNavigation/secondarynav';
import './whitelist.css';
export const Whitelist = () => {
    const { isAuthenticated, Moralis, enableWeb3, isWeb3Enabled } = useMoralis();
    const currentUser = isAuthenticated ? Moralis.User.current() : undefined;
    const [ chainId, setChainId ] = useState('');
    const [isUserEmailVerified, setIsUserEmailVerified] = useState(false);
    const [isUserAccountLinked, setIsUserAccountLinked] = useState(false);
    const [isUserWhitelisted, setIsUserWhitelisted] = useState(false);
    const [userWalletAddress, setUserWalletAddress] = useState('');
    const contractChainId = "0x4";
    
    useEffect(()=>{
        if(!isAuthenticated) return <Navigate to="/login"/>;
        if(!isWeb3Enabled) enableWeb3();
        setChainId(Moralis.getChainId());
    // eslint-disable-next-line
    },[isAuthenticated, enableWeb3,isWeb3Enabled, chainId])

    useEffect(()=>{
        if(currentUser?.attributes.emailVerified) setIsUserEmailVerified(currentUser?.attributes.emailVerified);
    // eslint-disable-next-line
    },[])

    useEffect(()=>{
        checkIfLinked().then(isLinked=>setIsUserAccountLinked(isLinked));
    // eslint-disable-next-line
    },[])

    useEffect(()=>{
        if(currentUser?.attributes.whitelisted) setIsUserWhitelisted(currentUser?.attributes.whitelisted);
    // eslint-disable-next-line
    },[])

    useEffect(()=>{
        if(currentUser?.attributes.ethAddress) setUserWalletAddress(currentUser?.attributes.ethAddress);
    // eslint-disable-next-line
    },[isUserAccountLinked, userWalletAddress])

    const checkIfLinked = async () => {
        if(currentUser && window.ethereum.selectedAddress !== undefined && window.ethereum.selectedAddress !== ''){
            if(currentUser.attributes.accounts === undefined){
                return false
            }
            return currentUser.attributes.accounts?.includes(window.ethereum.selectedAddress);
        }else{
            return false;
        }
    };
      
    const mergeLoginWithWallet = async () => {
        if(isAuthenticated && isUserEmailVerified && isWeb3Enabled){
            if (!isUserAccountLinked) {
                try{
                    await Moralis.link(window.ethereum.selectedAddress, { signingMessage: "Registering in Ruby NFT" });
                    setIsUserAccountLinked(true);
                }catch(error){
                    console.log(error);
                }
            }
        }
    }

    const whitelistWallet = () => {
        if(userWalletAddress){
            currentUser.set("whitelisted", true);
            currentUser.save();
            setIsUserWhitelisted(true);
        }
    }

    const renderOptions = () => {
        if(isAuthenticated && isUserEmailVerified && userWalletAddress && isUserWhitelisted){
            return   <>
                    <br/>
                    <p>Your wallet address is whitelisted!</p>
                    <p className='userWalletAddress'>{currentUser.attributes.ethAddress}</p>
                    <br/>
                    <Link
                        to='/mint'
                        className='btn btn-custom btn-lg'
                        >
                        Go to Mint
                    </Link>
                    </>
        }
        if(isAuthenticated && isUserEmailVerified && userWalletAddress){
            return  <>
                    <br/>
                    <p>Your wallet address is:</p>
                    <p className='userWalletAddress'>{currentUser.attributes.ethAddress}</p>
                    <button className='btn btn-custom btn-large connect-wallet-button' onClick={whitelistWallet}>Whitelist Wallet</button>
                    </>
        }
        if(isAuthenticated && isUserEmailVerified){
            return  <>
                    <p>Please connect your wallet</p>
                    <br/>
                    <button className='btn btn-custom btn-large connect-wallet-button' onClick={mergeLoginWithWallet}>Connect Wallet</button>
                    </>
        }
        if(isAuthenticated && !isUserEmailVerified){
            return <p>Check your email to validate your account and be able to register in the Whitelist. Once you've validated your account, please log-in again.</p>
        }
    }

    return (
        <>
        <SecondaryNavigation />
        {!isAuthenticated && <Navigate to="/login" replace/>}
        { chainId===contractChainId || 
            <div className='wrong-network'>Please connect your wallet to the Ethereum Network</div>
        }
        <div id="whitelist" className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    <h2>Whitelist</h2>
                    {renderOptions()}                    
                </div>
            </div>
        </div>
        </>
    )
}